import { PageHeader } from '@/components/PageHeader';
import { WellsDashboard } from '@/features/wells/components/WellsDashboard';

export function WellsPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Wells" subtitle="Live telemetry from your wells." />
      <WellsDashboard />
    </div>
  );
}
